import { m } from '../../motif/m';
import type { MotifComponent } from '../../motif/motifConstants';
import type { MotifComponentProps } from '../../motif/motifTypes';

export const mediaVars: MotifComponentProps<MotifComponent.MEDIA> = {
  '--media-border-radius': m('--border-radius-m'),
  '--media-border-width': '0px',
  '--media-border-color': 'unset',
};
